import { Component, Input, OnInit } from '@angular/core';
import { IProcessEventMetadata, ISystemEvent } from 'src/app/shared/interfaces/system-event.interface';

@Component({
    standalone: false,
    selector: 'app-process-events-list',
    templateUrl: './process-events-list.component.html',
    styleUrls: ['./process-events-list.component.scss', '../../../../../shared/styles/mdl-table.scss']
})
export class ProcessEventsListComponent implements OnInit {
    @Input()
    eventsList: ISystemEvent<IProcessEventMetadata>[];

    @Input()
    showParentType: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
